<template>
    <PageLayout title="Profile">
        <ContentCard v-if="!isLoading">
            <div class="profile-form">
                <div class="form-group">
                    <label>Email</label>
                    <input type="email" v-model="user.email" class="form-control" required>
                </div>
                <div class="form-group">
                    <label>Name</label>
                    <input type="text" v-model="user.name" class="form-control" required>
                </div>
                <div class="form-group">
                    <label>No Telp</label>
                    <input type="text" v-model="user.phone" class="form-control" required>
                </div>
                <div class="form-group">
                    <label>Timezone</label>
                    <select class="form-control" v-model="user.timezone">
                        <option v-for="tz in timezones" :key="tz.value" :value="tz.value">{{ tz.label }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Account API Key</label>
                    <input type="text" class="form-control" v-model="user.api_key" readonly>
                </div>
                <div class="form-group">
                    <label>Password Baru <span class="text-muted">(Kosongkan jika tidak ingin mengganti password)</span></label>
                    <input type="password" class="form-control" v-model="user.password" autocomplete="new-password">
                </div>
                <div class="profile-form__actions">
                    <button type="button" class="btn btn-primary btn-block" @click="updateUser">Simpan</button>
                    <button type="button" class="btn btn-outline-primary btn-block" @click="resetApiKey">Regenerate Account API Key</button>
                </div>
            </div>
        </ContentCard>
        <ContentCard v-else>
            <div class="profile-loading">
                <div class="spinner-border text-primary" role="status"></div>
            </div>
        </ContentCard>
    </PageLayout>
</template>

<script>
    export default {
        data() {
            return {
                isLoading: true,
                user: {},
                timezones: [
                    { value: -12, label: 'GMT -12' },
                    { value: -11, label: 'GMT -11' },
                    { value: -10, label: 'GMT -10' },
                    { value: -9, label: 'GMT -9' },
                    { value: -8, label: 'GMT -8' },
                    { value: -7, label: 'GMT -7' },
                    { value: -6, label: 'GMT -6' },
                    { value: -5, label: 'GMT -5' },
                    { value: -4, label: 'GMT -4' },
                    { value: -3, label: 'GMT -3' },
                    { value: -2, label: 'GMT -2' },
                    { value: -1, label: 'GMT -1' },
                    { value: 0, label: 'GMT 0' },
                    { value: 1, label: 'GMT +1' },
                    { value: 2, label: 'GMT +2' },
                    { value: 3, label: 'GMT +3' },
                    { value: 4, label: 'GMT +4' },
                    { value: 5, label: 'GMT +5' },
                    { value: 6, label: 'GMT +6' },
                    { value: 7, label: 'GMT +7' },
                    { value: 8, label: 'GMT +8' },
                    { value: 9, label: 'GMT +9' },
                    { value: 10, label: 'GMT +10' },
                    { value: 11, label: 'GMT +11' },
                    { value: 12, label: 'GMT +12' },
                ],
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            async loadData() {
                try {
                    let detail = await this.$store.dispatch("user_detail")
                    this.user = detail.data.data.user
                    this.user.reff_url = process.env.VUE_APP_FRONTEND_URL + "/register?reff=" + this.user.referral
                    this.user.password = ""
                    this.isLoading = false
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                    this.$router.push("/dashboard")
                }
            },
            async updateUser() {
                try {
                    let response = await this.$store.dispatch('user_update', {
                        ...this.user,
                        timezone: parseInt(this.user.timezone),
                    })
                    this.$toast.success(response.data.message)
                    this.loadData()
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
            },
            async resetApiKey() {
                try {
                    let response = await this.$store.dispatch('user_reset_api_key')
                    this.$toast.success(response.data.message)
                    this.loadData()
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                }
            },
        },
    }
</script>

<style scoped>
.profile-form .form-group {
    margin-bottom: 1.25rem;
}

.profile-form label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: var(--wc-text-heading);
}

.profile-form__actions {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 0.5rem;
}

.profile-loading {
    display: flex;
    justify-content: center;
    padding: 3rem 0;
}
</style>
